import BaseService from "../base";
import CreateSupportingFileStepService from "./createSupportingFileStepService";

class CreateSupportingFileService extends BaseService {
  getCreateSupportingFileStepItem = (
    para: any,
    success: any,
    error: any,
    interfaceList: any,
    mergePayloadMap: any
  ) => {
    CreateSupportingFileStepService.getStepData(
      para,
      success,
      error,
      interfaceList,
      mergePayloadMap
    );
  };

  createSupportingFileTriggerRevisePageAction = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("createSupportingFileTriggerRevisePageAction", para, success, error);
  };

  createSupportingFileTriggerApprovePageAction = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("createSupportingFileTriggerApprovePageAction", para, success, error);
  };

  updateSupportingFileTriggerRevisePageAction = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("updateSupportingFileTriggerRevisePageAction", para, success, error);
  };

  updateSupportingFileTriggerApprovePageAction = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("updateSupportingFileTriggerApprovePageAction", para, success, error);
  };

  getFlowStepData = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("getFlowStepData", para, success, error);
  };
}

const createSupportingFileService = new CreateSupportingFileService();

export default createSupportingFileService;
